import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

const conditions = [
  { value: 'new', label: 'New' },
  { value: 'like_new', label: 'Like New' },
  { value: 'good', label: 'Good' },
  { value: 'fair', label: 'Fair' },
  { value: 'poor', label: 'Poor' },
];

export default function ConditionFilter({ selectedCondition, onChange }) {
  const { theme } = useTheme();

  return (
    <div>
      <label className={`block text-sm font-medium mb-2 ${theme.text}`}>
        Condition
      </label>
      <select
        value={selectedCondition || ''}
        onChange={(e) => onChange(e.target.value || null)}
        className={`w-full px-3 py-2 rounded-lg border ${theme.border} ${theme.card} ${theme.text} focus:outline-none focus:ring-2 focus:ring-blue-500`}
      >
        <option value="">All Conditions</option>
        {conditions.map((condition) => (
          <option key={condition.value} value={condition.value}>
            {condition.label}
          </option>
        ))}
      </select>
    </div>
  );
}
